import React from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import PushSidebar from '../../components/MasterAdmin/push-notifications/PushSidebar';
import PushTemplatesPanel from '../../components/MasterAdmin/push-notifications/PushTemplatesPanel';
import PushDeliveryPanel from '../../components/MasterAdmin/push-notifications/PushDeliveryPanel';
import PushRecipientsPanel from '../../components/MasterAdmin/push-notifications/PushRecipientsPanel';
import PushFcmTokensPanel from '../../components/MasterAdmin/push-notifications/PushFcmTokensPanel';
import PushAnalyticsPanel from '../../components/MasterAdmin/push-notifications/PushAnalyticsPanel';
import PushCampaignEditorPage from '../../components/MasterAdmin/push-notifications/PushCampaignEditorPage';
import PushCampaignDetailPage from '../../components/MasterAdmin/push-notifications/PushCampaignDetailPage';
import PushTemplateEditorPage from '../../components/MasterAdmin/push-notifications/PushTemplateEditorPage';
import { pushMobileTabs, pushPageWrap, pushShell } from '../../components/MasterAdmin/push-notifications/pushHubUi';
import { PUSH_HUB_BASE_PATH, PUSH_HUB_TABS } from '../../models/MasterAdmin/pushNotificationHub';
import PushCampaignsPanel from './PushCampaignsPanel';

const PushMobileTabs: React.FC = () => (
  <div className={`${pushMobileTabs} md:hidden`}>
    {PUSH_HUB_TABS.map((tab) => (
      <NavLink
        key={tab.path}
        to={tab.path}
        end={tab.id === 'campaigns'}
        className={({ isActive }) =>
          `shrink-0 px-3 py-2.5 text-center text-xs font-medium whitespace-nowrap ${
            isActive
              ? 'border-b-2 border-blue-600 text-blue-600'
              : 'text-gray-600 dark:text-gray-300'
          }`
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </div>
);

const PushNotificationsPage: React.FC = () => {
  return (
    <div className={pushPageWrap}>
      <PushMobileTabs />
      <div className={pushShell}>
        <PushSidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <Routes>
            <Route index element={<PushCampaignsPanel />} />
            <Route path="campaigns/new" element={<PushCampaignEditorPage />} />
            <Route path="campaigns/:campaignId/edit" element={<PushCampaignEditorPage />} />
            <Route path="campaigns/:campaignId" element={<PushCampaignDetailPage />} />
            <Route path="campaigns" element={<PushCampaignsPanel />} />
            <Route path="templates/new" element={<PushTemplateEditorPage />} />
            <Route path="templates/:templateId/edit" element={<PushTemplateEditorPage />} />
            <Route path="templates" element={<PushTemplatesPanel />} />
            <Route path="recipients" element={<PushRecipientsPanel />} />
            <Route path="fcm-tokens" element={<PushFcmTokensPanel />} />
            <Route path="delivery" element={<PushDeliveryPanel />} />
            <Route path="analytics" element={<PushAnalyticsPanel />} />
            <Route path="*" element={<Navigate to={PUSH_HUB_BASE_PATH} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default PushNotificationsPage;
